import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useContext } from "react";
export const DEFAULT_CONFIG = {
    colors: {
        neutral00: "var(--color-neutral00)",
        neutral05: "var(--color-neutral05)",
        neutral10: "var(--color-neutral10)",
        neutral15: "var(--color-neutral15)",
        neutral20: "var(--color-neutral20)",
        neutral25: "var(--color-neutral25)",
        neutral30: "var(--color-neutral30)",
        neutral40: "var(--color-neutral40)",
        neutral50: "var(--color-neutral50)",
        neutral60: "var(--color-neutral60)",
        neutral70: "var(--color-neutral70)",
        neutral80: "var(--color-neutral80)",
        neutral90: "var(--color-neutral90)",
        danger0: "var(--color-danger0)",
        danger1: "var(--color-danger1)",
        danger2: "var(--color-danger2)",
        danger4: "var(--color-danger4)",
        danger5: "var(--color-danger5)",
        accent8: "var(--color-accent8)",
        accent7: "var(--color-accent7)",
        accent6: "var(--color-accent6)",
        accent5: "var(--color-accent5)",
        accent4: "var(--color-accent4)",
        focus: "var(--color-accent8)",
    },
    breakpoints: {
        small: 450,
        medium: 650,
        large: 900,
    },
};
const Context = React.createContext(DEFAULT_CONFIG);
/** Returns the current configuration for your component. */
export const useAppkitConfig = () => {
    return useContext(Context);
};
/**
 * Allows you to set a custom configuration for appkit components that are
 * (indirect) children of this component.
 */
export const AppkitConfigProvider = ({ config, children }) => (_jsx(Context.Provider, { value: config, children: children }));
//# sourceMappingURL=config.js.map